import { createClient } from "@supabase/supabase-js";

export const supabaseConfig = Object.freeze({
  projectRef: "vnezqgdmxgxrwnophhkt",
  projectName: "cgmobility",
  url: "https://vnezqgdmxgxrwnophhkt.supabase.co",
  publishableKey: "sb_publishable_blMuMKf7YIec2WUOuHgvXg_H6Y8Qp5J",
  interviewsTable: "interviews",
  deletionsTable: "deletion_requests",
  profilesTable: "profiles",
  adminUsersFunction: "admin-users",
  adminEmail: "caiogcg.mobilidade@gmail.com"
});

const supabase = createClient(
  supabaseConfig.url,
  supabaseConfig.publishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    },
    realtime: {
      params: { eventsPerSecond: 5 }
    }
  }
);

const supabasePing = fetch(`${supabaseConfig.url}/auth/v1/health`, {
  headers: { apikey: supabaseConfig.publishableKey }
})
  .then(response => {
    if (!response.ok) throw new Error(`Supabase indisponível (${response.status}).`);
    return { ok: true, checkedAt: new Date().toISOString() };
  })
  .catch(error => ({
    ok: false,
    checkedAt: new Date().toISOString(),
    error: String(error?.message || error)
  }));

export { supabase, supabasePing };
